import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getBrands,
  getCategories,
  getProducts,
  getUserId,
  getTopSellingProducts,
  getHealthCategories,
  getOfferProducts,
} from "../../features/feature1/feature1Slice";
import Slider from "react-slick";
// import { Url } from '../../config/config';

import Cookies from "js-cookie";
import Banner from "./Banner";
import { discount1, discount2, finallogo, frame } from "../../imgUrl";
import { Link, useNavigate } from "react-router-dom";

const Homepage = () => {
  // const Base_url = "http://18.233.85.48:8080/api/";
  const navigate = useNavigate(); // Initialize useNavigate hook
  const dispatch = useDispatch();
  const [cartQuantities, setCartQuantities] = useState({});
  const [inCart, setInCart] = useState({}); // State to track if a product is in the cart
  const {
    brands,
    categories,
    products,
    topSellingProducts,
    healthcategories,
    offers,
    status,
  } = useSelector((state) => state.feature1);

  useEffect(() => {
    dispatch(getUserId());
    dispatch(getBrands());
    dispatch(getCategories());
    dispatch(getProducts());
    dispatch(getTopSellingProducts());
    dispatch(getHealthCategories());
    dispatch(getOfferProducts()); // Dispatch top-selling products
  }, [dispatch]);

  const ConditionalSlider = ({ items, settings, renderItem, minItems = 6 }) => {
    if (!items || items.length < minItems) {
      return <div className="condiiotn-slider">{items?.map(renderItem)}</div>;
    }
    return <Slider {...settings}>{items.map(renderItem)}</Slider>;
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleCategoryClick = (categoryId) => {
    navigate(`/products?category=${categoryId}`);
  };

  const handleHealthCategoryClick = (healthcategoryId) => {
    navigate(`/products?healthCategory=${healthcategoryId}`);
  };

  // Function to handle adding to cart
  const calculateDiscountedPrice = (variant) => {
    if (variant.discount && variant.discount.discount_type === "perc") {
      return variant.price * (1 - variant.discount.discount / 100);
    } else if (variant.discount && variant.discount.discount_type === "fixed") {
      return Math.max(0, variant.price - variant.discount.discount);
    }
    return variant.price;
  };

  const addToCart = (product, productType) => {
    // const availableVariant = product.variants.find((v) => v.inStock);
    // if (!availableVariant) return;

    // const selectedVariant = product.variant[0];
    const selectedVariant = product.variants?.[0] || product.variant?.[0];

    const quantity = cartQuantities[product._id]
      ? cartQuantities[product._id]
      : 1;
    const cartItem = {
      id: product._id,
      title: product.title,
      isRequirePrescription: product.isRequirePrescription,
      variant: {
        id: selectedVariant._id,
        name: selectedVariant.name,
        size: selectedVariant.size,
        price: selectedVariant.price,
        discountedPrice: calculateDiscountedPrice(selectedVariant),
        discountDetails: selectedVariant.discount
          ? {
              discount: selectedVariant.discount.discount,
              discount_type: selectedVariant.discount.discount_type,
            }
          : null,
      },
      quantity: quantity,
      price: calculateDiscountedPrice(selectedVariant) * quantity,
      originalPrice: selectedVariant.price * quantity,
      image:
        productType === "selling"
          ? product?.mediaFiles?.[0]?.url || null
          : product?.media?.[0]?.url || null,
      media_id:
        productType === "selling"
          ? product.mediaFiles?.[0]?._id || null
          : product.media?.[0]?._id || null,
      discount_id: selectedVariant.discounted_id || null,
    };

    const currentCart = Cookies.get("cart")
      ? JSON.parse(Cookies.get("cart"))
      : [];

    const existingItemIndex = currentCart.findIndex(
      (item) =>
        item.id === cartItem.id && item.variant.id === cartItem.variant.id
    );

    if (existingItemIndex > -1) {
      currentCart[existingItemIndex].quantity += cartItem.quantity;
      currentCart[existingItemIndex].price += cartItem.price;
    } else {
      currentCart.push(cartItem);
    }

    Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 });
    setInCart((prev) => ({ ...prev, [product._id]: true }));
    setCartQuantities((prevState) => ({
      ...prevState,
      [product._id]: (prevState[product._id] || 0) + 1,
    }));
  };

  // Function to handle incrementing product quantity
  const incrementQuantity = (productId, product, productType) => {
    setCartQuantities((prevState) => {
      const newQuantity = (prevState[productId] ? prevState[productId] : 0) + 1;

      // Update the cart in cookies with the new quantity
      const currentCart = Cookies.get("cart")
        ? JSON.parse(Cookies.get("cart"))
        : [];
      const existingItemIndex = currentCart.findIndex(
        (item) => item.id === productId
      );

      if (existingItemIndex > -1) {
        currentCart[existingItemIndex].quantity = newQuantity; // Update quantity
        currentCart[existingItemIndex].price = calculateItemPrice(
          currentCart[existingItemIndex].variant,
          newQuantity
        );
        currentCart[existingItemIndex].image =
          productType === "selling"
            ? product?.mediaFiles?.[0]?.url || null
            : product?.media?.[0]?.url || null;
      }

      Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 }); // Save to cookies

      return { ...prevState, [productId]: newQuantity }; // Update state
    });
  };

  // Function to handle decrementing product quantity
  const decrementQuantity = (productId) => {
    setCartQuantities((prevState) => {
      const newQuantity = Math.max((prevState[productId] || 1) - 1, 0);

      // Update the cart in cookies with the new quantity
      const currentCart = Cookies.get("cart")
        ? JSON.parse(Cookies.get("cart"))
        : [];
      const existingItemIndex = currentCart.findIndex(
        (item) => item.id === productId
      );

      if (existingItemIndex > -1) {
        currentCart[existingItemIndex].quantity = newQuantity; // Update quantity
        currentCart[existingItemIndex].price = calculateItemPrice(
          currentCart[existingItemIndex].variant,
          newQuantity
        );
      }

      Cookies.set("cart", JSON.stringify(currentCart), { expires: 7 }); // Save to cookies

      return { ...prevState, [productId]: newQuantity }; // Update state
    });
  };

  // Helper function to calculate item price with discount
  const calculateItemPrice = (variant, quantity) => {
    if (variant.discountDetails) {
      const { discount, discount_type } = variant.discountDetails;
      if (discount_type === "perc") {
        return variant.price * (1 - discount / 100) * quantity;
      } else if (discount_type === "fixed") {
        return Math.max(0, (variant.price - discount) * quantity);
      }
    }
    return variant.price * quantity;
  };

  const addedCartItem = () => {
    const cart = Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : [];
    const cartData = cart?.filter((cartData) => cartData?.quantity > 0);
    const updatedInCart = {};
    cartData?.forEach((item) => {
      updatedInCart[item.id] = true;
    });
    setInCart(updatedInCart);
    const updatedCartQuantities = {};
    cartData?.forEach((item) => {
      updatedCartQuantities[item.id] = item.quantity;
    });
    setCartQuantities(updatedCartQuantities);
  };

  function formatCategoryName(name) {
    return name
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  useEffect(() => {
    addedCartItem();
  }, []);
  return (
    <div className="main-page-start">
      <Banner />

      <div className="container ">
        {/* Shop By Category Section */}
        {/* <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="shop-by-category">
              <h2 className="text-2xl font-bold mb-6">Shop By Category</h2>
              <ConditionalSlider
                items={categories}
                settings={settings}
                renderItem={(category) => (
                  <div
                    key={category._id}
                    className="category-products px-4"
                    onClick={() => handleCategoryClick(category._id)}
                  >
                    <div className="productss">
                      <img
                        className=""
                        src={category.category_img}
                        alt={category.name}
                      />
                      <span className="block text-center mt-2 font-medium">
                        {category.name}
                      </span>
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div> */}

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="best-selling">
              <div className="best-selling-heading">
                <h2>Healthy Picks of the season</h2>
                <Link to="/products">View All</Link>
              </div>
              <div className="best-selling-container row top-sell-products">
                {topSellingProducts?.slice(0, 6)?.map((product) => {
                  const selectedVariant = product.variants[0];
                  const originalPrice = selectedVariant?.price || 0;
                  const discountPercentage =
                    selectedVariant?.discount?.discount || 0;
                  const discountedPrice =
                    originalPrice - (originalPrice * discountPercentage) / 100;

                  const isInCart = inCart[product._id]; // Check if product is in the cart
                  const cartQuantity = cartQuantities[product._id] || 1; // Get cart quantity

                  return (
                    <div
                      key={product._id}
                      className="best-selling-products col-sm-2 col-lg-2 col-md-4 "
                    >
                      <Link to={`/productdetails/${product._id}`}>
                        <div className="image-container">
                          <img
                            src={`${product.media[0]?.url || ""}`}
                            alt={product.title}
                          />
                        </div>
                        <div className="content-container">
                          <h4>{product.title}</h4>
                          <div className="price">
                            <div className="amount">
                              ₹{discountedPrice.toFixed(2)}{" "}
                              <del>(₹{originalPrice})</del>
                            </div>
                            <div className="discount">
                              {discountPercentage
                                ? `${discountPercentage}% off`
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                      </Link>

                      <div className="quantity-control">
                        {cartQuantities[product._id] > 0 ? (
                          <div className="increment-decrement-buttons">
                            <button
                              onClick={() => decrementQuantity(product._id)}
                            >
                              -
                            </button>
                            <span>
                              {cartQuantities[product._id]
                                ? cartQuantities[product._id]
                                : 0}
                            </span>
                            <button
                              onClick={() =>
                                incrementQuantity(
                                  product._id,
                                  product,
                                  "top-sell"
                                )
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => addToCart(product, "top-sell")}
                            className="addtocart"
                          >
                            ADD TO CART
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Shop By Brand Section */}
        <div className="row mb-8">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="shop-by-brand">
              <h2 className="text-2xl font-bold mb-6">Shop By Brand</h2>
              <div className="brand-slider">
                <ConditionalSlider
                  items={brands}
                  settings={settings}
                  renderItem={(brand) => (
                    <div
                      key={brand.id}
                      className="brand-image "
                      onClick={() => navigate(`/products?brand=${brand._id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        className=""
                        src={brand.brand_logo}
                        alt={brand.name}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="loyalty-program">
              <div className="loyalty-image">
                <img src={frame} alt="fram" />
              </div>
              <div className="loyalty-content">
                <h4>
                  a loyalty program will offer rewards and special deals to
                  regular users
                </h4>
                <p>
                  Our aim is to provide a reliable, safe, and convenient online
                  shopping experience for all medical needs.
                </p>
                <a href="#">SHOP NOW</a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="best-selling">
              <div className="best-selling-heading">
                <h2>Best Sellings</h2>
                <Link to="/products">View All</Link>
              </div>
              <div className="best-selling-container row best-sell-products">
                {products?.slice(0, 12)?.map((product) => {
                  const originalPrice = product.variant[0]?.price || 0;
                  const discountPercentage =
                    product.variant[0]?.discount?.discount || 0;
                  const discountedPrice =
                    originalPrice - (originalPrice * discountPercentage) / 100;

                  return (
                    <div
                      key={product._id}
                      className="best-selling-products col-sm-2 col-lg-2 col-md-4 mb-5 position-relative"
                    >
                      <Link to={`/productdetails/${product._id}`}>
                        <div className="image-container">
                          <img
                            src={
                              product.mediaFiles?.[0]?.url
                                ? product.mediaFiles?.[0]?.url || ""
                                : finallogo
                            }
                            alt={product.title}
                          />
                        </div>
                        <div className="content-container">
                          <h4>{product.title}</h4>
                          <div className="price">
                            <div className="amount">
                              ₹{discountedPrice.toFixed(2)}{" "}
                              <del>(₹{originalPrice})</del>
                            </div>
                            <div className="discount">
                              {discountPercentage
                                ? `${discountPercentage}% off`
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                      </Link>

                      <div className="quantity-control">
                        {cartQuantities[product._id] > 0 ? (
                          <div className="increment-decrement-buttons">
                            <button
                              onClick={() => decrementQuantity(product._id)}
                            >
                              -
                            </button>
                            <span>
                              {cartQuantities[product._id]
                                ? cartQuantities[product._id]
                                : 0}
                            </span>
                            <button
                              onClick={() =>
                                incrementQuantity(
                                  product._id,
                                  product,
                                  "selling"
                                )
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => addToCart(product, "selling")}
                            className="addtocart"
                          >
                            ADD TO CART
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="health-conditions">
              {/* Your component code */}
              <h2>Categories</h2>
              <div className="condition-container category-products-data">
                {categories.map((category) => (
                  <div
                    key={category._id}
                    className="codition-details"
                    onClick={() => handleCategoryClick(category._id)}
                  >
                    <div className="productss">
                      <img
                        src={`${category.category_img}`}
                        alt={category.name}
                        
                      />
                      <h6>{formatCategoryName(category?.name)}</h6>
                      <button className="category-button">Shop Now</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="discount-banner">
              <div className="discount-banner-img1">
                <img src={discount1} alt="" />
              </div>
              <div className="discount-banner-content">
                <h4>10% to 15% off on branded medicines</h4>
                <Link to="/uploadprescription">UPLOAD PRESCRIPTION</Link>
                {/* <a href="#"></a> */}
              </div>
              <div className="discount-banner-img2">
                <img src={discount2} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="last-product-section">
              <div className="last-section-heading">
                <h2>Minimum 50% Off</h2>
                <a href="#">View All</a>
              </div>
              <div className="last-section-container row">
                {status === "loading" ? (
                  <p>Loading...</p>
                ) : (
                  offers.map((offer) => {
                    // Accessing the first variant
                    const firstVariant = offer.variant[0];

                    // Pricing calculation
                    const originalPrice = firstVariant?.price || 0;
                    const discountPercentage =
                      firstVariant?.discount?.discount || 0;
                    const discountedPrice =
                      originalPrice -
                      (originalPrice * discountPercentage) / 100;

                    return (
                      <div
                        key={offer._id}
                        className="last-section-products col-sm-2"
                      >
                        <div className="image-container">
                          <Link to={`/productdetails/${offer._id}`}>
                            <div className="image-container">
                              <img
                                src={offer.mediaFiles?.[0]?.url || ""}
                                alt={offer.title}
                              />
                            </div>
                          </Link>
                        </div>
                        <div className="content-container">
                          <h4>{offer.title}</h4>
                          <div className="price">
                            <div className="amount">
                              ₹{discountedPrice.toFixed(2)}
                              {/* Discounted price */}
                              <del>(₹{originalPrice})</del>{" "}
                              {/* Original price */}
                            </div>
                            <div className="discount">
                              {discountPercentage > 0
                                ? `${discountPercentage}% OFF`
                                : "N/A"}
                            </div>
                          </div>
                          <div className="quantity-control">
                            {inCart[offer._id] ? (
                              <div className="increment-decrement-buttons">
                                <button
                                  onClick={() => decrementQuantity(offer._id)}
                                >
                                  -
                                </button>
                                <span>{cartQuantities[offer._id] || 1}</span>
                                <button
                                  onClick={() => incrementQuantity(offer._id)}
                                >
                                  +
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={() => addToCart(offer)}
                                className="addtocart"
                              >
                                ADD TO CART
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>

        {/* CSS Styles */}
        <style jsx>{`
          .brand-image img {
            transition: transform 0.3s ease;
          }
          .brand-image:hover img {
            transform: scale(1.05);
          }
          .category-products {
            cursor: pointer;
            transition: transform 0.3s ease;
          }
          .category-products:hover {
            transform: translateY(-5px);
          }
        `}</style>
      </div>

      <div>
        <div className="container-fluid">
          {/* Your component code */}
          {/* <div className="shop-by-category">
            <h2>Shop By Category</h2>
            <Slider {...settings} className="category-slider">
              {categories.map((category) => (
                <div
                  key={category._id}
                  className="category-products"
                  onClick={() => handleCategoryClick(category._id)}
                >
                  <div className="productss">
                    <img src={`${category.category_img}`} alt={category.name} />
                    <span>{category.name}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div> */}

          {/* <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="top-selling">
                <div className="top-selling-heading">
                  <h2>Top Selling &amp; Supplements</h2>
                  <Link to="/products">View All</Link>
                </div>
                <div className="top-selling-container row">
                  {topSellingProducts.map((product) => {
                    const selectedVariant = product.variants[0];
                    const originalPrice = selectedVariant?.price || 0;
                    const discountPercentage =
                      selectedVariant?.discount?.discount || 0;
                    const discountedPrice =
                      originalPrice -
                      (originalPrice * discountPercentage) / 100;

                    const isInCart = inCart[product._id]; // Check if product is in the cart
                    const cartQuantity = cartQuantities[product._id] || 1; // Get cart quantity

                    return (
                      <div
                        className="top-selling-products col-sm-2"
                        key={product._id}
                      >
                        <div className="image-container">
                          <Link to={`/productdetails/${product._id}`}>
                            <img
                              src={`${product.media[0]?.url || ""}`}
                              alt={product.title}
                            />
                          </Link>
                        </div>
                        <div className="content-container">
                          <h4>{product.title}</h4>
                          <div className="price">
                            <div className="amount">
                              ₹{discountedPrice.toFixed(2)}{" "}
                              <del className="ps-1">
                                (₹{originalPrice.toFixed(2)})
                              </del>
                            </div>
                            <div className="discount">
                              {discountPercentage
                                ? `${discountPercentage}% off`
                                : "N/A"}
                            </div>
                          </div>
                          <div className="quantity-control">
                            {isInCart ? (
                              <>
                                <div className="increment-decrement-buttons">
                                  <button
                                    onClick={() =>
                                      decrementQuantity(product._id)
                                    }
                                  >
                                    -
                                  </button>
                                  <span>{cartQuantity}</span>
                                  <button
                                    onClick={() =>
                                      incrementQuantity(product._id)
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </>
                            ) : (
                              <button
                                onClick={() => addToCart(product)}
                                className="addtocart"
                              >
                                ADD TO CART
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="shop-by-brand">
                <h2>Shop By Brand</h2>

                <div className="brand-slider">
                  <Slider {...settings}>
                    {brands.map((brand) => (
                      <div
                        key={brand.id}
                        className="brand-image"
                        onClick={() => navigate(`/products?brand=${brand._id}`)} // Use _id if that's the correct field for brand ID
                        style={{ cursor: "pointer" }} // Add pointer style for clarity
                      >
                        <img
                          width={100}
                          src={brand.brand_logo}
                          alt={brand.name}
                        />
                        <h3>{brand.name}</h3>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Homepage;
